import { render, staticRenderFns } from "./UserIdentifyingFieldGroup.vue?vue&type=template&id=b1f66e40&scoped=true&"
import script from "./UserIdentifyingFieldGroup.vue?vue&type=script&lang=ts&"
export * from "./UserIdentifyingFieldGroup.vue?vue&type=script&lang=ts&"
import style0 from "./UserIdentifyingFieldGroup.vue?vue&type=style&index=0&id=b1f66e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f66e40",
  null
  
)

export default component.exports